window.$ = window.jQuery = require('jquery');
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './bootstrap';
import './modules/page-header';
import './modules/text-carousel';
import './modules/header-sizer';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        //key: '',
        //libraries: 'places', // This is required if you use the Autocomplete plugin
    }
});


$(document).on('domReady', () => {
    setTimeout(() => $('body').addClass('ready'), 1000);
    $('img.img-shadow').addClass('active');
});


new Vue({
    el: '#app',

    data: {
        states: {
            navOpen: false,
            navTransition: false,
            searchOpen: false,
            searchTransition: false,
        }
    },

    watch: {
        'states.navOpen'(val) {
            setTimeout(() => {
                this.states.navTransition = val;
            }, 300);
        },
        'states.searchOpen'(val) {
            setTimeout(() => {
                this.states.searchTransition = val;
            }, 300);
        },
    },

    mounted() {
        this.$nextTick(() => $(document).trigger('domReady'));
    }
});
